
import { api } from "../api/requests";

// Get All Non Motor Claims
export async function getAllNonMotorClaims(page: number, size: number, searchParam?: string, policyType?: string, stage?: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/non-motor-claims?page=${page}&size=${size}${searchParam ? `&searchParam=${searchParam}` : ''}${policyType ? `&policyType=${policyType}` : ''}${stage ? `&stage=${stage}` : ''}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Create a new claim with full details
export async function createNonMotorClaim(payload: any): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/non-motor-claims`, payload)
            .then((response: any) => {
                console.log("response", response)
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get a single claim by claim number
export async function getNonMotorClaimByClaimNumber(claimNumber: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/non-motor-claims/${claimNumber}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Update claim details
export async function updateNonMotorClaim(claimNumber: string, payload: any): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/non-motor-claims/${claimNumber}`, payload)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Approve claim amount
export async function approveNonMotorClaim(claimNumber: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/non-motor-claims/${claimNumber}/approve`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Assign claim to a staff member
export async function assignNonMotorClaim(claimNumber: string, staffId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/non-motor-claims/${claimNumber}/assign/${staffId}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Mark claim as paid
export async function markNonMotorClaimAsPaid(claimNumber: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/non-motor-claims/${claimNumber}/pay`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Reject claim
export async function rejectNonMotorClaim(claimNumber: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/non-motor-claims/${claimNumber}/reject`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Update claim stage
export async function updateNonMotorClaimStage(claimNumber: string, newStage: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/non-motor-claims/${claimNumber}/stage/${newStage}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get claims by customer ID
export async function getNonMotorClaimsByCustomerId(customerId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/non-motor-claims/customer/${customerId}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get claims by customer ID
export async function getNonMotorClaimsByPolicyNumber(policyNumber: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/non-motor-claims/policy/${policyNumber}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get claims statistics
export async function getNonMotorClaimsStatistics(): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/non-motor-claims/statistics`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get claims by status
export async function getNonMotorClaimsByStatus(status: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/non-motor-claims/status/${status}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Get claims by staff ID
export async function getNonMotorClaimsByStaffId(staffId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/non-motor-claims/staff/${staffId}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Generate a new claim from an existing non - motor policy
export async function generateNonMotorClaimFromPolicy(policyNumber: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/non-motor-claims/generate/${policyNumber}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Add a note to claim
export async function addNoteToNonMotorClaim(claimNumber: string, payload: any): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/non-motor-claims/${claimNumber}/updates`, payload)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}
// Add a note to claim
export async function updateNonMotorClaimNote(claimNumber: string, noteId: number, payload: any): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/non-motor-claims/${claimNumber}/updates/${noteId}`, payload)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Add a note to claim
export async function deleteNonMotorClaimNote(claimNumber: string, noteId: number): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.delete(`admin/non-motor-claims/${claimNumber}/updates/${noteId}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Approve non motor claim and submit to insurer
export async function approveNonMotorClaimAndSubmitToInsurer(claimNumber: string, notes: string | null): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.put(`admin/non-motor-claims/${claimNumber}/approve${notes ? `?assessorNotes=${notes}` : ""}`)
            .then((response: any) => {
                resolve(response?.data?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}
